module.exports = __webpack_public_path__ + "static/media/sneakers.cea98123.gif";